const PageRoutes = {
  getPages: 'gpt/pages/list',
  getMetaData: 'gpt/pages/metadata',
  pageReindex: 'gpt/pages/reIndex',
  deletePage: 'gpt/pages/delete',
  getPageMetaData: 'gpt/pages/metadata',
};

export default PageRoutes